import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { clearErrors, getAllProductsHome } from '../actions/productAction'
import { useSelector, useDispatch } from 'react-redux'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useAlert } from 'react-alert'

import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
} from 'swiper'

const Acdap = () => {
  const alert = useAlert()
  const dispatch = useDispatch()
  const { loading, error, products } = useSelector((state) => state.products)
  useEffect(() => {
    if (error) {
      alert.error(error)
      dispatch(clearErrors())
    }
    dispatch(getAllProductsHome())
  }, [dispatch, error, alert])

  return (
    <>
      {/*<!-- Page Banner Section Start -->*/}
      <div
        className='section page-banner-section'
        style={{ backgroundImage: 'url(../assets/images/banner.jpg)' }}
      >
        <div className='overlayBanner'></div>
        <div className='container'>
          {/*<!-- Page Banner Content End -->*/}
          <div className='page-banner-content'>
            <h2 className='title'>ACDAP</h2>

            <ul className='breadcrumb'>
              <li>
                <Link to='/'>Home</Link>
              </li>
              <li className='active'>ACDAP</li>
            </ul>
          </div>
          {/*<!-- Page Banner Content End -->*/}
        </div>
      </div>
      {/*<!-- Page Banner Section End -->*/}

      {/*<!-- New Product Section Start -->*/}
      <div className='section section-padding'>
        <div className='container'>
          <div className='product-section-wrapper courseSecPanel'>
            <div className='row justify-content-center'>
              <div className='col-lg-12'>
                <div className='product-wrapper product-active'>
                  <div className='product-top-wrapper'>
                    <div className='section-title order-md-1'>
                      <h6>ACDAP COURSES</h6>
                      <h2 className='title'>Courses</h2>
                    </div>
                  </div>
                  <div className='courseSec col-lg-8 col-12 m-auto'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>DAP</a>
                            </h4>
                            <div className=''>
                              <p>
                                <span>
                                  Full Course - Digital Bookkeeper &amp; Payroll
                                  Administrator
                                </span>{' '}
                                Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>DAA</a>
                            </h4>
                            <div className='d-flex align-items-center justify-content-center'>
                              <p>
                                <span>
                                  Full Course - Digital Assistant Accountant
                                </span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>DAP</a>
                            </h4>
                            <div className=''>
                              <p>
                                <span>
                                  Full Course - Digital Accounting Professional
                                </span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row justify-content-center'>
              <div className='col-lg-12'>
                <div className='product-wrapper product-active'>
                  <div className='product-top-wrapper'>
                    <div className='section-title order-md-1'>
                      <h6>ACDAP COURSES</h6>
                      <h2 className='title'>Courses</h2>
                    </div>
                  </div>
                  <div className='courseSec col-lg-8 col-12 m-auto'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>BPA</a>
                            </h4>
                            <div className=''>
                              <p>
                                <span>
                                  Fast Track—Digital Bookkeeper &amp; Payroll
                                  Administrator
                                </span>{' '}
                                Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>DAA</a>
                            </h4>
                            <div className='d-flex align-items-center justify-content-center'>
                              <p>
                                <span>
                                  Fast Track—Digital Assistant Accountant{' '}
                                </span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>DAP</a>
                            </h4>
                            <div className=''>
                              <p>
                                <span>
                                  Fast Track—Digital Accounting Professional
                                </span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*<!-- New Product Section End -->*/}
    </>
  )
}

export default Acdap
